import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import axios from "api/axios";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import PageShell, { SectionCard } from "components/patch/PageShell";
import SimpleTable from "components/patch/SimpleTable";

const tabs = {
  "/settings/security": { label: "Security Overview", endpoint: null },
  "/settings/users": {
    label: "Users",
    endpoint: "/admin/users",
    columns: ["id", "name", "email", "status"],
  },
  "/settings/roles": { label: "Roles", endpoint: "/admin/roles", columns: ["id", "code", "name"] },
  "/settings/permissions": {
    label: "Permissions",
    endpoint: "/admin/permissions",
    columns: ["id", "module", "code", "name"],
  },
  "/settings/menus": {
    label: "Menus",
    endpoint: "/admin/menus",
    columns: ["id", "name", "code", "route_path"],
  },
  "/settings/activity-logs": {
    label: "Activity Logs",
    endpoint: "/admin/activity-logs",
    columns: ["id", "module", "action", "remarks"],
  },
  "/settings/login-logs": {
    label: "Login Logs",
    endpoint: "/admin/login-logs",
    columns: ["id", "login_status", "ip_address", "login_at"],
  },
  "/security-admin/users": {
    label: "Users",
    endpoint: "/admin/users",
    columns: ["id", "name", "email", "status"],
  },
  "/security-admin/roles": {
    label: "Roles",
    endpoint: "/admin/roles",
    columns: ["id", "code", "name"],
  },
  "/security-admin/permissions": {
    label: "Permissions",
    endpoint: "/admin/permissions",
    columns: ["id", "module", "code", "name"],
  },
  "/security-admin/menus": {
    label: "Menus",
    endpoint: "/admin/menus",
    columns: ["id", "name", "code", "route_path"],
  },
  "/security-admin/security-logs": {
    label: "Activity Logs",
    endpoint: "/admin/activity-logs",
    columns: ["id", "module", "action", "remarks"],
  },
};

export default function SecurityLogs() {
  const location = useLocation();
  const current = tabs[location.pathname] || tabs["/settings/security"];
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!current.endpoint) return;
    axios
      .get(current.endpoint)
      .then((res) => {
        setRows(res.data?.data || res.data || []);
      })
      .catch(() => setRows([]));
  }, [current.endpoint]);

  const nav = [
    ["Users", "/settings/users"],
    ["Roles", "/settings/roles"],
    ["Permissions", "/settings/permissions"],
    ["Menus", "/settings/menus"],
    ["Activity Logs", "/settings/activity-logs"],
    ["Login Logs", "/settings/login-logs"],
  ];

  const columns = (current.columns || []).map((c) => ({
    key: c,
    label: c.replaceAll("_", " ").toUpperCase(),
  }));

  return (
    <PageShell
      title="Security & Admin"
      subtitle="Access control, menu setup and security audit records."
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <SectionCard title="Navigation">
            <MDBox display="flex" flexDirection="column" gap={1}>
              {nav.map(([label, path]) => (
                <MDButton
                  component={Link}
                  to={path}
                  key={path}
                  variant={location.pathname === path ? "gradient" : "outlined"}
                  color="info"
                >
                  {label}
                </MDButton>
              ))}
            </MDBox>
          </SectionCard>
        </Grid>
        <Grid item xs={12} md={9}>
          {!current.endpoint ? (
            <SectionCard
              title="Security Overview"
              subtitle="Pick a security submenu to manage users, roles, menus or review logs."
            />
          ) : (
            <SectionCard title={current.label}>
              <SimpleTable columns={columns} rows={rows} />
            </SectionCard>
          )}
        </Grid>
      </Grid>
    </PageShell>
  );
}
